import React from 'react';
import { Text, VStack, HStack } from '@chakra-ui/react';
import { FiCheckCircle, FiDollarSign, FiZap } from 'react-icons/fi';
import ModalShell from './ui/ModalShell';
import { ff } from '../theme';

interface FoodFluenceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onGetStarted?: () => void;
}

const FEATURES = [
  { icon: FiCheckCircle, label: 'Direct collabs' },
  { icon: FiDollarSign, label: 'Fast pay' },
  { icon: FiZap, label: 'Quick setup' },
];

const FoodFluenceModal: React.FC<FoodFluenceModalProps> = ({ isOpen, onClose, onGetStarted }) => {
  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      title="What is FoodFluence?"
      primary={{ label: 'Get started', onClick: onGetStarted || onClose, tone: 'ink' }}
    >
      <VStack spacing={5} align="stretch">
        <VStack spacing={3} align="stretch">
          <Text fontSize="15px" color={ff.body} lineHeight="1.5">
            FoodFluence connects local influencers and content creators with restaurants and brands for collaborations and content creation.
          </Text>
          <Text fontSize="15px" color={ff.body} lineHeight="1.5">
            We handle the details so you can focus on what matters most — creating amazing content and getting paid for your work.
          </Text>
        </VStack>

        <HStack spacing={2} justify="space-between">
          {FEATURES.map(({ icon: FeatureIcon, label }) => (
            <VStack key={label} flex={1} spacing={2} py={3} bg={ff.limeSurface} borderRadius="16px">
              <FeatureIcon size={20} color={ff.ink} aria-hidden />
              <Text fontSize="13px" fontWeight={600} color={ff.ink}>
                {label}
              </Text>
            </VStack>
          ))}
        </HStack>
      </VStack>
    </ModalShell>
  );
};

export default FoodFluenceModal;
